/* 🤖 this file was generated by svg-to-ts */
export const emperorIconPrinter: {
  name: 'printer';
  data: string;
} = {
  name: 'printer',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22.0039 11C22.0039 9.346 20.6579 8 19.0039 8H17.0039V10H7.00391V8H5.00391C3.34991 8 2.00391 9.346 2.00391 11V20H5.00391V24H19.0039V20H22.0039V11ZM17.0039 22H7.00391V18H17.0039V22ZM20.0039 18H19.0039V16H5.00391V18H4.00391V11C4.00391 10.448 4.45291 10 5.00391 10V12H19.0039V10C19.5549 10 20.0039 10.448 20.0039 11V18Z"/><path d="M7.00391 3H17.0039V7H19.0039V1H5.00391V7H7.00391V3Z"/><path d="M17.0039 15C17.5562 15 18.0039 14.5523 18.0039 14C18.0039 13.4477 17.5562 13 17.0039 13C16.4516 13 16.0039 13.4477 16.0039 14C16.0039 14.5523 16.4516 15 17.0039 15Z"/></svg>`
};
